var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMerchants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.15,
    height: 30,
    viewBox: "0 0 35.15 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "store_FILL0_wght200_GRAD0_opsz48",
    d: "M8.85,10.55V9H39.2v1.55ZM9.15,39V26.6H6.45V25.05L8.85,15h30.3L41.6,25.05V26.6H38.9V39H37.4V26.6H26.7V39Zm1.5-1.55h14.5V26.6H10.65Zm-2.7-12.4h0Zm0,0h32.1l-2-8.5H9.95Z",
    transform: "translate(-6.45 -9)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMerchants);
export default __webpack_public_path__ + "static/media/iconMerchants.10653ac1def60b03e17c1c2540ebab8f.svg";
export { ForwardRef as ReactComponent };